import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter,Routes,Route } from "react-router-dom";
import { createRoot } from 'react-dom/client';
// import './font.css';
import './index.scss';
import Forgotpwans from 'Components/Forgotpw/Forgotpwans';
import App from './App';

import reportWebVitals from './reportWebVitals';
import { FlowProvider } from 'flow-react';

const container = document.getElementById('root');
const root = createRoot(container);

// const wsurl = "http://localhost:3000/api/initws";
const wsurl = "https://www.francetvpreview.fr/flow2/api/initws";
// const wsurl = "https://francetv.demo.flowcenter.de/flow2/api/initws";

root.render(
  <React.StrictMode>
    <FlowProvider apiurl={wsurl} config={{pingtime: 20,throwonfail: false}}>
				
			<BrowserRouter>
				<Routes>
					<Route path="resetpassword" element={<Forgotpwans />} />
					<Route path="ftvpreview/resetpassword/:resetid" element={<Forgotpwans />} />
					<Route path="ftvpreview/deleteme" element={<App deletelink="yes" />} />
					<Route path="*" element={<App />} />
				</Routes>
			</BrowserRouter>				
				
    </FlowProvider>
  </React.StrictMode>,
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
